module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/default2-eaaf7b50ccde96559461d1307e899aed.png";